import React from 'react';
import { motion } from 'framer-motion';
import { Shield, AlertTriangle, Clock, Users } from 'lucide-react';

const Disclaimer = () => {
  return (
    <section className="py-16 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 font-medium text-sm mb-4">
            <Shield className="w-4 h-4" />
            <span>Transparency & Trust</span>
          </div>
          <h2 className="text-3xl font-bold mb-3">Important Disclaimer</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            We believe in complete transparency. Here's what you should know before getting started.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50"
          >
            <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mb-4">
              <AlertTriangle className="w-6 h-6 text-amber-400" />
            </div>
            <h3 className="text-lg font-bold mb-2 text-white">No Job Guarantee</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We provide the tools and strategy; the final hiring decision rests solely with the employer or hiring company. We control the process, not the outcome.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50"
          >
            <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-4">
              <Clock className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="text-lg font-bold mb-2 text-white">Refund Policy</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              Refunds are only available within 24 hours of payment and before any document review has begun. After that, we offer a 2-week service extension instead.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50"
          >
            <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center mb-4">
              <Users className="w-6 h-6 text-green-400" />
            </div>
            <h3 className="text-lg font-bold mb-2 text-white">Limited Capacity</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We work with only 5–7 clients at a time to ensure premium, dedicated service. Availability is on a first-come, first-served basis.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
